import { Controller } from "@hotwired/stimulus"

// The nav is data-turbo-permanent, so its cart badge won't re-render on Turbo navigations.
// This keeps it in sync by reading the current count off <body data-cart-count> (which IS
// re-rendered each navigation) on every turbo:load.
export default class extends Controller {
  connect() {
    this.sync = this.sync.bind(this)
    document.addEventListener("turbo:load", this.sync)
    this.sync()
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.sync)
  }

  sync() {
    const count = parseInt(document.body.dataset.cartCount || "0", 10)
    this.element.querySelectorAll("[data-cart-badge]").forEach((badge) => {
      badge.textContent = count > 0 ? String(count) : ""
      badge.classList.toggle("hidden", count <= 0)
    })
  }
}
